import axios from "axios";

import { ENDPOINT, GOOGLE_MAP_API_KEY, USE_DIRECT_GOOGLE_IMAGE } from "../../constant/environment";
import { decryptData, encryptData, getHeaderConfig } from "../../utils/api/encryption";
import { isValidJWT } from "../../utils/authentication/isValidJWT";

export async function getItineraryImageURL(
  accessJWT: string,
  cityName: string,
  country?: string,
  count?: number,
  source?: "Google" | "Unsplash"
) {
  const URL = `${ENDPOINT}/app/v1/itineraries/getImage`;
  const body = {
    imageName: cityName,
    ...(country ? { country } : {}),
    ...(count && count > 1 ? { count } : {}),
    ...(source ? { source } : {}),
  };
if (!accessJWT || !isValidJWT(accessJWT)) return null;
  let config = getHeaderConfig(null, accessJWT);
  try {
    const response = await axios.post(URL, encryptData(body), config);
    const decryptedData = decryptData(response?.data);
    return decryptedData ? JSON.parse(decryptedData) : null;
  } catch (error: any) {
    return { statusCode: 200, data: { image: "" } };
  }
}
